import { render, staticRenderFns } from "./RegulatoryInformationTabComponent.vue?vue&type=template&id=38e78aa8&scoped=true&"
import script from "./RegulatoryInformationTabComponent.vue?vue&type=script&lang=js&"
export * from "./RegulatoryInformationTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e78aa8",
  null
  
)

export default component.exports